import { createFeatureSelector } from '@ngrx/store';
import { SEO_FEATURE_NAME } from './feature-name';

export const getSEOState = createFeatureSelector(SEO_FEATURE_NAME);
